import { convertToExportedView } from '@estee/elc-service';
import { IApptBookingLanding } from './ApptBookingLanding';
import serviceNames from '../../service-setup/ApptBookingService';
import '../../css/main.css';

/*eslint no-restricted-syntax: ["off"]*/
// @ts-ignore
export default convertToExportedView<IApptBookingLanding>(
    () => import('./ApptBookingLanding'),
    'appt-booking-landing',
    serviceNames.apptBookingLandingViewController
);
